import 'slick-carousel'
import { find, findFirst } from 'helpers/vanilla'

//const $ = window.jQuery

const MobileSlider = () => {

  const name = 'slider_mobile'
  let $slider_mobile
  let $slider_el = $('.gallery-images')

  const loadCondition = () => {
    $slider_mobile = findFirst('.gallery-images')
    return $slider_mobile
  }

  const init = () => {

    var $slider = $('.gallery-images');

    var settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      mobileFirst: true,
      responsive: [
          {
            breakpoint: 769,
            settings: "unslick"
          }
      ]
    }

    $slider.slick(settings);

  }

  const resize = () => {

    if ($(window).width() > 769) {
      if ($slider_el.hasClass('slick-initialized')) {
        $slider_el.slick('unslick');
      }
      return
    }

    if (!$slider.hasClass('slick-initialized')) {
      return $slider.slick(settings);
    }

  }

  //init()
  return { loadCondition, name, init, resize }
}

export default MobileSlider



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/components/slider-mobile.js